import { SharedToolsService, ToolsModule } from 'libs/shared/src/tools';
import { Component, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { GenericTableHeaderComponent, GenericTableHeaderOptions } from '@huge-monorepo/shared/components';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { ActivatedRoute, Data } from '@angular/router';
import { log } from 'console';
import { SharedTeltonikaSingletonService } from '@huge-monorepo/shared/services';
import { IHIPTeltonikaService, ICustomerTeltonikaService } from '@huge-monorepo/shared/interfaces';
import { NavigationTabConfig } from 'libs/hip/tools/src/lib/tools/navigation-tab/navigation-tab.component';


@Component({
  selector: 'huge-monorepo-teltonika-device-reporting',
  standalone: true,
  imports: [CommonModule, MatCardModule, GenericTableHeaderComponent, MaterialModule, ToolsModule],
  templateUrl: './teltonika-device-reporting.component.html',
  styleUrl: './teltonika-device-reporting.component.scss',
})
export class TeltonikaDeviceReportingComponent implements OnInit {
  @Input() wanSchedulingEnabled: boolean = false;

  teltonikaService = this.sharedTeltonikaService.getService();
  isHip = this.sharedTeltonikaService.getIsHIP();
  loading: boolean = false;

  headerConfig: GenericTableHeaderOptions = {
    DateRequired: true,
    EnableExport: true,
    DateItem: {
      Singular: false,
      Title: "Report Generation Period",
      Type: 'day'
    },
  };

  data: any = [];
  wanData: any = [];
  id: number = 0;

  Temperature?: DataValues;
  WirelessClientCount?: DataValues;
  SignalStrength?: DataValues;
  DataUsage?: { [ServiceProvider: string]: number };
  dates: { startDate: Date, endDate: Date };
  DeviceUptime: DataValues;
  DeviceDowntime: DataValues;
  ConnectionUptime: DataValues;
  ConnectionDowntime: DataValues;

  WANUptime: DataValues;
  WANDowntime: DataValues;
  WANTotalTx?: number;
  WANTotalRx?: number;

  wanDates: { startDate: Date, endDate: Date };

  selectedTabIndex: number = 0;

  selectedTab: string = "Device Reporting";

  tabConfig: NavigationTabConfig[];

  constructor(
    private sharedTeltonikaService: SharedTeltonikaSingletonService<ICustomerTeltonikaService | IHIPTeltonikaService>,
    private activatedRoute: ActivatedRoute,
    private tool: SharedToolsService) { }

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe(
      (paraMap: any) => {
        if (paraMap.params.id) {
          this.id = +paraMap.params.id;

        }
      }

    );

    this.tabConfig = [{
      title: "Device Reporting",
      visible: true,
    },
    {
      title: "WAN Reporting",
      visible: this.isHip || (!this.isHip && this.wanSchedulingEnabled),
    }];
  }

  exportData() {
    this.loading = true;
    this.teltonikaService.exportReportingData([this.id], this.dates?.startDate, this.dates?.endDate).subscribe(
      {
        next: (data) => {
          this.loading = false;
        },
        error: (error) => {
          console.error(error);
          this.loading = false;
        },
        complete: () => {
          this.loading = false;
        }
      }
    );
  }

  updateDates(dates: { startDate: Date, endDate: Date }) {
    this.dates = dates;
    this.loading = true;
    if (dates.startDate == null || dates.endDate == null) {
      this.loading = false;
      return;
    }
    let endDate = new Date(dates.endDate);
    endDate.setDate(endDate.getDate() - 1);
    endDate.setHours(23, 59, 59);

    this.teltonikaService.getReportingData([this.id], dates.startDate, dates.endDate).subscribe(
      {
        next: (data) => {
          this.data = data;
          this.processData(data[this.id], dates.startDate, endDate);
          this.loading = false;
        },
        error: (error) => {
          console.error(error);
          this.loading = false;
        }
      }
    );
  }

  processData(data: any, startDate: Date, endDate: Date) {

    if (data == null) {
      return;
    }

    let deviceOrderedEvents: { Start: Date, End: Date, IsUp: boolean }[] = [];
    let connectionOrderedEvents: { Start: Date, End: Date, IsUp: boolean }[] = [];

    data.Data.forEach((element: any) => {
      if (element.Temperature && element.Temperature.Total) {
        if (!this.Temperature) {
          this.Temperature = { Total: element.Temperature.Total, Min: element.Temperature.Min, Max: element.Temperature.Max, NumberOfEntries: element.Temperature.NumberOfEntries };
        } else {
          this.Temperature.NumberOfEntries += element.Temperature.NumberOfEntries;
          this.Temperature.Total += element.Temperature.Total;
          if (element.Temperature.Min < this.Temperature.Min) {
            this.Temperature.Min = element.Temperature.Min;
          }
          if (element.Temperature.Max > this.Temperature.Max) {
            this.Temperature.Max = element.Temperature.Max;
          }
        }
      }
      if (element.WirelessClientCount && element.WirelessClientCount.Total) {
        if (!this.WirelessClientCount) {
          this.WirelessClientCount = { Total: element.WirelessClientCount.Total, Min: element.WirelessClientCount.Min, Max: element.WirelessClientCount.Max, NumberOfEntries: element.WirelessClientCount.NumberOfEntries };
        } else {
          this.WirelessClientCount.NumberOfEntries += element.WirelessClientCount.NumberOfEntries;
          this.WirelessClientCount.Total += element.WirelessClientCount.Total;
          if (element.WirelessClientCount.Min < this.WirelessClientCount.Min) {
            this.WirelessClientCount.Min = element.WirelessClientCount.Min;
          }
          if (element.WirelessClientCount.Max > this.WirelessClientCount.Max) {
            this.WirelessClientCount.Max = element.WirelessClientCount.Max;
          }
        }
      }
      if (element.RSSI && element.RSSI.Total) {
        if (!this.SignalStrength) {
          this.SignalStrength = { Total: element.RSSI.Total, Min: element.RSSI.Min, Max: element.RSSI.Max, NumberOfEntries: element.RSSI.NumberOfEntries };
        } else {
          this.SignalStrength.NumberOfEntries += element.RSSI.NumberOfEntries;

          this.SignalStrength.Total += element.RSSI.Total;
          if (element.RSSI.Min < this.SignalStrength.Min) {
            this.SignalStrength.Min = element.RSSI.Min;
          }
          if (element.RSSI.Max > this.SignalStrength.Max) {
            this.SignalStrength.Max = element.RSSI.Max;
          }
        }
      }
      if (element.Uptime && element.Uptime.Uptimes && element.DownTime && element.DownTime.Downtimes && (element.Uptime.Uptimes.length > 0 || element.DownTime.Downtimes.length > 0)) {
        element.Uptime.Uptimes.forEach((uptime: TimeEntry) => {
          deviceOrderedEvents.push({ Start: new Date(uptime.Start), End: new Date(uptime.End), IsUp: true });
        });
        element.DownTime.Downtimes.forEach((downtime: TimeEntry) => {
          deviceOrderedEvents.push({ Start: new Date(downtime.Start), End: new Date(downtime.End), IsUp: false });
        });
      }
      if (element.ConnectionUptime && element.ConnectionUptime.Uptimes && element.ConnectionDowntime && element.ConnectionDowntime.Downtimes && (element.ConnectionUptime.Uptimes.length > 0 || element.ConnectionDowntime.Downtimes.length > 0)) {
        element.ConnectionUptime.Uptimes.forEach((uptime: TimeEntry) => {
          connectionOrderedEvents.push({ Start: new Date(uptime.Start), End: new Date(uptime.End), IsUp: true });
        });
        element.ConnectionDowntime.Downtimes.forEach((downtime: TimeEntry) => {
          connectionOrderedEvents.push({ Start: new Date(downtime.Start), End: new Date(downtime.End), IsUp: false });
        });

      }

    });
    if (deviceOrderedEvents.length > 0) {
      deviceOrderedEvents.sort((a, b) => {
        return a.End.getTime() - b.End.getTime();
      });

      let finalisedEvents: { Start: Date, End: Date, IsUp: boolean }[] = [];
      let finalisedEventsIndex = 0;
      deviceOrderedEvents.forEach((element, i) => {
        if (i > 0 && deviceOrderedEvents[i - 1].End.getTime() == (element.Start.getTime() - 1000) && deviceOrderedEvents[i - 1].IsUp == element.IsUp) {
          finalisedEvents[finalisedEventsIndex - 1].End = element.End;
        }
        else if (i > 0 && element.Start.getTime() > deviceOrderedEvents[i - 1].End.getTime()) {
          if (element.IsUp) {
            finalisedEvents.push({ Start: deviceOrderedEvents[i - 1].End, End: element.Start, IsUp: false });
            finalisedEventsIndex++;
          }
          finalisedEvents.push(element);
          finalisedEventsIndex++;
        } else {
          finalisedEvents.push(element);
          finalisedEventsIndex++;
        }
      });

      if (finalisedEvents[0].IsUp && finalisedEvents[0].Start > startDate) {

        finalisedEvents.unshift({ Start: startDate, End: finalisedEvents[0].Start, IsUp: false });
      }

      if (finalisedEvents[finalisedEvents.length - 1].IsUp && finalisedEvents[finalisedEvents.length - 1].End < endDate) {
        finalisedEvents.push({ Start: finalisedEvents[finalisedEvents.length - 1].End, End: endDate, IsUp: false });

      }



      let minUptime = Infinity, maxUptime = 0, totalUptime = 0;
      let minDowntime = Infinity, maxDowntime = 0, totalDowntime = 0;

      let currentStart = new Date(finalisedEvents[0].Start);
      let currentEnd = new Date(finalisedEvents[0].End);
      let currentState = finalisedEvents[0].IsUp;
      let uptimeCounter = 0;
      let downtimeCounter = 0;

      for (let i = 1; i < finalisedEvents.length; i++) {
        if (finalisedEvents[i].IsUp === currentState) {

          currentEnd = new Date(finalisedEvents[i].End);
        } else {
          if (currentState) {
            uptimeCounter++;
          } else {
            downtimeCounter++;
          }
          const duration = (currentEnd.getTime() - currentStart.getTime()) / 1000;
          if (currentState) {
            totalUptime += duration;
            minUptime = Math.min(minUptime, duration);
            maxUptime = Math.max(maxUptime, duration);
          } else {
            totalDowntime += duration;
            minDowntime = Math.min(minDowntime, duration);
            maxDowntime = Math.max(maxDowntime, duration);
          }

          currentStart = new Date(finalisedEvents[i].Start);
          currentEnd = new Date(finalisedEvents[i].End);
          currentState = finalisedEvents[i].IsUp;
        }
      }
      if (currentState) {
        uptimeCounter++;
      } else {
        downtimeCounter++;
      }

      const duration = (currentEnd.getTime() - currentStart.getTime()) / 1000;
      if (currentState) {
        totalUptime += duration;
        minUptime = Math.min(minUptime, duration);
        maxUptime = Math.max(maxUptime, duration);
      } else {
        totalDowntime += duration;
        minDowntime = Math.min(minDowntime, duration);
        maxDowntime = Math.max(maxDowntime, duration);
      }

      if (!this.DeviceUptime) {
        this.DeviceUptime = { Total: totalUptime, Min: minUptime !== Infinity ? minUptime : 0, Max: maxUptime, NumberOfEntries: uptimeCounter };
      } else {
        this.DeviceUptime.NumberOfEntries += uptimeCounter;
        this.DeviceUptime.Total += totalUptime;
        if (minUptime < this.DeviceUptime.Min) {
          this.DeviceUptime.Min = minUptime;
        }
        if (maxUptime > this.DeviceUptime.Max) {
          this.DeviceUptime.Max = maxUptime;
        }
      }


      if (!this.DeviceDowntime) {
        this.DeviceDowntime = { Total: totalDowntime, Min: minDowntime !== Infinity ? minDowntime : 0, Max: maxDowntime, NumberOfEntries: downtimeCounter };
      } else {
        this.DeviceDowntime.NumberOfEntries += downtimeCounter;
        this.DeviceDowntime.Total += totalDowntime;
        if (minDowntime < this.DeviceDowntime.Min) {
          this.DeviceDowntime.Min = minDowntime;
        }
        if (maxDowntime > this.DeviceDowntime.Max) {
          this.DeviceDowntime.Max = maxDowntime;
        }
      }
    } else {
      this.DeviceUptime = { Total: 0, Min: 0, Max: 0, NumberOfEntries: 0 };
      this.DeviceDowntime = { Total: (endDate.getTime() - startDate.getTime()) / 1000, Min: (endDate.getTime() - startDate.getTime()) / 1000, Max: (endDate.getTime() - startDate.getTime()) / 1000, NumberOfEntries: 1 };
    }

    if (connectionOrderedEvents.length > 0) {
      connectionOrderedEvents.sort((a, b) => {
        return a.End.getTime() - b.End.getTime();
      });

      let finalisedEvents: { Start: Date, End: Date, IsUp: boolean }[] = [];
      let finalisedEventsIndex = 0;
      connectionOrderedEvents.forEach((element, i) => {
        if (i > 0 && connectionOrderedEvents[i - 1].End.getTime() == (element.Start.getTime() - 1000) && connectionOrderedEvents[i - 1].IsUp == element.IsUp) {
          finalisedEvents[finalisedEventsIndex - 1].End = element.End;
        }
        else if (i > 0 && element.Start.getTime() > connectionOrderedEvents[i - 1].End.getTime()) {
          if (element.IsUp) {
            finalisedEvents.push({ Start: connectionOrderedEvents[i - 1].End, End: element.Start, IsUp: false });
            finalisedEventsIndex++;
          }
          finalisedEvents.push(element);
          finalisedEventsIndex++;
        } else {
          finalisedEvents.push(element);
          finalisedEventsIndex++;
        }
      });

      if (finalisedEvents[0].IsUp && finalisedEvents[0].Start > startDate) {

        finalisedEvents.unshift({ Start: startDate, End: finalisedEvents[0].Start, IsUp: false });
      }

      if (finalisedEvents[finalisedEvents.length - 1].IsUp && finalisedEvents[finalisedEvents.length - 1].End < endDate) {
        finalisedEvents.push({ Start: finalisedEvents[finalisedEvents.length - 1].End, End: endDate, IsUp: false });

      }



      let minUptime = Infinity, maxUptime = 0, totalUptime = 0;
      let minDowntime = Infinity, maxDowntime = 0, totalDowntime = 0;

      let currentStart = new Date(finalisedEvents[0].Start);
      let currentEnd = new Date(finalisedEvents[0].End);
      let currentState = finalisedEvents[0].IsUp;
      let uptimeCounter = 0;
      let downtimeCounter = 0;

      for (let i = 1; i < finalisedEvents.length; i++) {
        if (finalisedEvents[i].IsUp === currentState) {

          currentEnd = new Date(finalisedEvents[i].End);
        } else {
          if (currentState) {
            uptimeCounter++;
          } else {
            downtimeCounter++;
          }

          const duration = (currentEnd.getTime() - currentStart.getTime()) / 1000;

          if (currentState) {
            totalUptime += duration;
            minUptime = Math.min(minUptime, duration);
            maxUptime = Math.max(maxUptime, duration);
          } else {
            totalDowntime += duration;

            minDowntime = Math.min(minDowntime, duration);
            maxDowntime = Math.max(maxDowntime, duration);
          }

          currentStart = new Date(finalisedEvents[i].Start);
          currentEnd = new Date(finalisedEvents[i].End);
          currentState = finalisedEvents[i].IsUp;
        }
      }
      if (currentState) {
        uptimeCounter++;
      } else {
        downtimeCounter++;
      }

      const duration = (currentEnd.getTime() - currentStart.getTime()) / 1000;

      if (currentState) {
        totalUptime += duration;
        minUptime = Math.min(minUptime, duration);
        maxUptime = Math.max(maxUptime, duration);
      } else {
        totalDowntime += duration;
        minDowntime = Math.min(minDowntime, duration);
        maxDowntime = Math.max(maxDowntime, duration);
      }

      if (!this.ConnectionUptime) {
        this.ConnectionUptime = { Total: totalUptime, Min: minUptime !== Infinity ? minUptime : 0, Max: maxUptime, NumberOfEntries: uptimeCounter };
      } else {
        this.ConnectionUptime.NumberOfEntries += uptimeCounter;
        this.ConnectionUptime.Total += totalUptime;
        if (minUptime < this.ConnectionUptime.Min) {
          this.ConnectionUptime.Min = minUptime;
        }
        if (maxUptime > this.ConnectionUptime.Max) {
          this.ConnectionUptime.Max = maxUptime;
        }
      }


      if (!this.ConnectionDowntime) {
        this.ConnectionDowntime = { Total: totalDowntime, Min: minDowntime !== Infinity ? minDowntime : 0, Max: maxDowntime, NumberOfEntries: downtimeCounter };
      } else {
        this.ConnectionDowntime.NumberOfEntries += downtimeCounter;
        this.ConnectionDowntime.Total += totalDowntime;
        if (minDowntime < this.ConnectionDowntime.Min) {
          this.ConnectionDowntime.Min = minDowntime;
        }
        if (maxDowntime > this.ConnectionDowntime.Max) {
          this.ConnectionDowntime.Max = maxDowntime;
        }
      }
    } else {
      this.ConnectionUptime = { Total: 0, Min: 0, Max: 0, NumberOfEntries: 0 };

      this.ConnectionDowntime = { Total: (endDate.getTime() - startDate.getTime()) / 1000, Min: (endDate.getTime() - startDate.getTime()) / 1000, Max: (endDate.getTime() - startDate.getTime()) / 1000, NumberOfEntries: 1 };
    }



    if (data.DataUsage) {
      data.DataUsage.forEach((element: any) => {
        if (!this.DataUsage) {
          this.DataUsage = {};
        }
        if (this.DataUsage[element.ServiceProvider]) {
          this.DataUsage[element.ServiceProvider] += element.TotalUsage;
        } else {
          this.DataUsage[element.ServiceProvider] = element.TotalUsage;
        }
      });
    }

    this.WANTotalTx = 0;
    this.WANTotalRx = 0;
    if (data.WANTotalTx !== undefined) {
      this.WANTotalTx = data.WANTotalTx;
    }

    if (data.WANTotalRx !== undefined) {
      this.WANTotalRx = data.WANTotalRx;
    }
  }

  getThreeMonthsAgo(): Date {
    const currentDate = new Date();

    const threeMonthsAgo = new Date();
    threeMonthsAgo.setMonth(currentDate.getMonth() - 3);
    return threeMonthsAgo;
  }

  convertFromSeconds(input: number) {
    const rounded = Math.round(input);
    const hours = Math.floor(rounded / 3600);
    const minutes = Math.floor((rounded % 3600) / 60);
    const seconds = rounded % 60;
    return `${hours} h ${minutes} m ${seconds} s`;
  }

  changeTab(tab: string) {
    this.selectedTab = tab;
    this.selectedTabIndex = this.tabConfig.findIndex((t) => t.title === tab) ?? 0;
  }


  exportWANData() {
    this.loading = true;
    this.teltonikaService.exportWANReportingData([this.id], this.wanDates?.startDate, this.wanDates?.endDate).subscribe(
      {
        next: (data) => {
          this.loading = false;
        },
        error: (error) => {
          console.error(error);
          this.loading = false;
        },
        complete: () => {
          this.loading = false;
        }
      }
    );
  }

  updateWANDates(dates: { startDate: Date, endDate: Date }) {
    this.wanDates = dates;
    this.loading = true;
    if (dates.startDate == null || dates.endDate == null) {
      this.loading = false;
      return;
    }
    let endDate = new Date(dates.endDate);
    endDate.setDate(endDate.getDate() - 1);
    endDate.setHours(23, 59, 59);

    this.teltonikaService.getWANReportingData([this.id], dates.startDate, dates.endDate).subscribe(
      {
        next: (data) => {
          this.wanData = data;
          this.processWANData(data[this.id], dates.startDate, endDate);

          this.loading = false;
        },
        error: (error) => {
          console.error(error);
          this.loading = false;
        }
      }
    );
  }

  processWANData(data: any, startDate: Date, endDate: Date) {
    if (data == null) {
      return;
    }

    let wanOrderedEvents: { Start: Date, End: Date, IsUp: boolean }[] = [];

    data.Data.forEach((element: any) => {

      if (element.Uptime && element.Uptime.Uptimes && element.DownTime && element.DownTime.Downtimes && (element.Uptime.Uptimes.length > 0 || element.DownTime.Downtimes.length > 0)) {
        element.Uptime.Uptimes.forEach((uptime: TimeEntry) => {
          wanOrderedEvents.push({ Start: new Date(uptime.Start), End: new Date(uptime.End), IsUp: true });
        });
        element.DownTime.Downtimes.forEach((downtime: TimeEntry) => {
          wanOrderedEvents.push({ Start: new Date(downtime.Start), End: new Date(downtime.End), IsUp: false });
        });
      }

    });
    if (wanOrderedEvents.length > 0) {
      wanOrderedEvents.sort((a, b) => {
        return a.End.getTime() - b.End.getTime();
      });

      let finalisedEvents: { Start: Date, End: Date, IsUp: boolean }[] = [];
      let finalisedEventsIndex = 0;
      wanOrderedEvents.forEach((element, i) => {
        if (i > 0 && wanOrderedEvents[i - 1].End.getTime() == (element.Start.getTime() - 1000) && wanOrderedEvents[i - 1].IsUp == element.IsUp) {
          finalisedEvents[finalisedEventsIndex - 1].End = element.End;
        }
        else if (i > 0 && element.Start.getTime() > wanOrderedEvents[i - 1].End.getTime()) {
          if (element.IsUp) {
            finalisedEvents.push({ Start: wanOrderedEvents[i - 1].End, End: element.Start, IsUp: false });
            finalisedEventsIndex++;
          }
          finalisedEvents.push(element);
          finalisedEventsIndex++;
        } else {
          finalisedEvents.push(element);
          finalisedEventsIndex++;
        }
      });

      if (finalisedEvents[0].IsUp && finalisedEvents[0].Start > startDate) {

        finalisedEvents.unshift({ Start: startDate, End: finalisedEvents[0].Start, IsUp: false });
      }

      if (finalisedEvents[finalisedEvents.length - 1].IsUp && finalisedEvents[finalisedEvents.length - 1].End < endDate) {
        finalisedEvents.push({ Start: finalisedEvents[finalisedEvents.length - 1].End, End: endDate, IsUp: false });

      }



      let minUptime = Infinity, maxUptime = 0, totalUptime = 0;
      let minDowntime = Infinity, maxDowntime = 0, totalDowntime = 0;

      let currentStart = new Date(finalisedEvents[0].Start);
      let currentEnd = new Date(finalisedEvents[0].End);
      let currentState = finalisedEvents[0].IsUp;
      let uptimeCounter = 0;
      let downtimeCounter = 0;

      for (let i = 1; i < finalisedEvents.length; i++) {
        if (finalisedEvents[i].IsUp === currentState) {

          currentEnd = new Date(finalisedEvents[i].End);
        } else {
          if (currentState) {
            uptimeCounter++;
          } else {
            downtimeCounter++;
          }
          const duration = (currentEnd.getTime() - currentStart.getTime()) / 1000;
          if (currentState) {
            totalUptime += duration;
            minUptime = Math.min(minUptime, duration);
            maxUptime = Math.max(maxUptime, duration);
          } else {
            totalDowntime += duration;
            minDowntime = Math.min(minDowntime, duration);
            maxDowntime = Math.max(maxDowntime, duration);
          }

          currentStart = new Date(finalisedEvents[i].Start);
          currentEnd = new Date(finalisedEvents[i].End);
          currentState = finalisedEvents[i].IsUp;
        }
      }
      if (currentState) {
        uptimeCounter++;
      } else {
        downtimeCounter++;
      }

      const duration = (currentEnd.getTime() - currentStart.getTime()) / 1000;
      if (currentState) {
        totalUptime += duration;
        minUptime = Math.min(minUptime, duration);
        maxUptime = Math.max(maxUptime, duration);
      } else {
        totalDowntime += duration;
        minDowntime = Math.min(minDowntime, duration);
        maxDowntime = Math.max(maxDowntime, duration);
      }

      if (!this.WANUptime) {
        this.WANUptime = { Total: totalUptime, Min: minUptime !== Infinity ? minUptime : 0, Max: maxUptime, NumberOfEntries: uptimeCounter };
      } else {
        this.WANUptime.NumberOfEntries += uptimeCounter;
        this.WANUptime.Total += totalUptime;
        if (minUptime < this.WANUptime.Min) {
          this.WANUptime.Min = minUptime;
        }
        if (maxUptime > this.WANUptime.Max) {
          this.WANUptime.Max = maxUptime;
        }
      }


      if (!this.WANDowntime) {
        this.WANDowntime = { Total: totalDowntime, Min: minDowntime !== Infinity ? minDowntime : 0, Max: maxDowntime, NumberOfEntries: downtimeCounter };
      } else {
        this.WANDowntime.NumberOfEntries += downtimeCounter;
        this.WANDowntime.Total += totalDowntime;
        if (minDowntime < this.WANDowntime.Min) {
          this.WANDowntime.Min = minDowntime;
        }
        if (maxDowntime > this.WANDowntime.Max) {
          this.WANDowntime.Max = maxDowntime;
        }
      }
    } else {
      this.WANUptime = { Total: 0, Min: 0, Max: 0, NumberOfEntries: 0 };
      this.WANDowntime = { Total: (endDate.getTime() - startDate.getTime()) / 1000, Min: (endDate.getTime() - startDate.getTime()) / 1000, Max: (endDate.getTime() - startDate.getTime()) / 1000, NumberOfEntries: 1 };
    }

    this.WANTotalTx = 0;
    this.WANTotalRx = 0;
    if (data.WANTotalTx !== undefined) {
      this.WANTotalTx = data.WANTotalTx;
    }

    if (data.WANTotalRx !== undefined) {
      this.WANTotalRx = data.WANTotalRx;
    }
  }

}

type DataValues = {
  Total: number,
  Min: number,
  Max: number,
  NumberOfEntries: number,
}

type TimeEntry = {
  Start: Date,
  End: Date,
}

